import API from "../api";

export const getClassroomStatus = () =>
  API.get("/classroom/status").then((r) => r.data);

export const getClassroomLive = (studentId) =>
  API.get("/classroom/live", {
    params: studentId ? { studentId } : undefined,
  }).then((r) => r.data);

export const getClassroomSettings = () =>
  API.get("/classroom/settings").then((r) => r.data);

export const saveClassroomSettings = (payload) =>
  API.put("/classroom/settings", payload).then((r) => r.data);

export const startSessionClassroom = (sessionId) =>
  API.post(`/staff/sessions/${sessionId}/classroom/start`, null, { timeout: 60000 }).then(
    (r) => r.data,
  );

export const endSessionClassroom = (sessionId) =>
  API.post(`/staff/sessions/${sessionId}/classroom/end`).then((r) => r.data);

export const getSessionClassroom = (sessionId, studentId) =>
  API.get(`/classroom/sessions/${sessionId}`, {
    params: studentId ? { studentId } : undefined,
  }).then((r) => r.data);

export const getClassroomEmbedAuth = (sessionId, { studentId } = {}) =>
  API.get(`/classroom/sessions/${sessionId}/embed-auth`, {
    params: {
      ...(studentId ? { studentId } : {}),
    },
    timeout: 60000,
  }).then((r) => r.data);

/** In-app meeting route for a portal role. */
export function classroomMeetingPath(role, sessionId, { studentId, host } = {}) {
  const portal = String(role || 'student').toLowerCase();
  const base = `/${portal}/classroom/meeting/${sessionId}`;
  const params = new URLSearchParams();
  if (studentId) params.set('studentId', String(studentId));
  if (host) params.set('host', '1');
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

function isMobileBrowser() {
  if (typeof navigator === "undefined") return false;
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || "");
}

/**
 * Open Zoom. On mobile, always same-tab — window.open after await is blocked
 * and looks like "Join does nothing".
 */
export function openClassroomZoomUrl(url) {
  if (!url || typeof url !== "string" || !url.trim()) return false;
  const href = url.trim();
  try {
    if (isMobileBrowser()) {
      window.location.assign(href);
      return true;
    }
    const win = window.open(href, "_blank");
    if (!win) {
      window.location.assign(href);
    }
    return true;
  } catch {
    try {
      window.location.assign(href);
      return true;
    } catch {
      return false;
    }
  }
}

/**
 * Call synchronously in the click handler BEFORE any await, then
 * finishClassroomZoomOpen(handle, url) after the API returns.
 * Preserves the user-gesture on desktop; mobile uses same-tab.
 */
export function beginClassroomZoomOpen() {
  if (isMobileBrowser()) {
    return { mode: "same-tab" };
  }
  try {
    const win = window.open("about:blank", "_blank");
    if (win) return { mode: "tab", win };
  } catch {
    /* ignore */
  }
  return { mode: "same-tab" };
}

export function finishClassroomZoomOpen(handle, url) {
  if (!url || typeof url !== "string" || !url.trim()) {
    if (handle?.mode === "tab" && handle.win && !handle.win.closed) {
      try {
        handle.win.close();
      } catch {
        /* ignore */
      }
    }
    return false;
  }
  const href = url.trim();
  if (handle?.mode === "tab" && handle.win && !handle.win.closed) {
    try {
      handle.win.location.href = href;
      return true;
    } catch {
      /* fall through */
    }
  }
  window.location.assign(href);
  return true;
}
